import { render, staticRenderFns } from "./pageTable.vue?vue&type=template&id=36b1f36e&scoped=true&"
import script from "./pageTable.vue?vue&type=script&lang=js&"
export * from "./pageTable.vue?vue&type=script&lang=js&"
import style0 from "./pageTable.vue?vue&type=style&index=0&id=36b1f36e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b1f36e",
  null
  
)

export default component.exports